// ================================================= /
// ======   FORM JS   ============================== /
// ================================================= /

/* global jQuery */

/**
 * Class for helpers
 */
class DispatchSkinForm {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.formSelector = '.js-form';
		this.fieldSelector = `${this.selector}__field`;

		this.eventNamespace = 'DispatchSkinForm';
		this.focusClass = 'has-focus';
		this.focusedFieldsClass = 'has-focused-fields';
		this.floatingLabelClass = 'has-floating-label';
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		if ( jQuery( this.formSelector ).length ) {

			this.eventDelegationParent = jQuery( '.site' );

			// Input focus
			this.eventDelegationParent.on(
				`focus.${this.eventNamespace}`,
				this.formSelector + ' :input:not([type="submit"])',
				( event ) => this.focusInput( jQuery( event.target ) )
			);
			this.eventDelegationParent.on(
				`focusout.${this.eventNamespace}`,
				this.formSelector + ' :input',
				() => this.blurInput( jQuery( event.target ) )
			);
			this.eventDelegationParent.on(
				`change.${this.eventNamespace}`,
				this.formSelector + ' select',
				() => this.blurInput( jQuery( event.target ) )
			);
		}
	}

	/* Form methods ----------------------------------------- */

	/**
	 * Focuses an input.
	 */
	focusInput( input, formSelector = this.formSelector, fieldSelector = this.fieldSelector ) {

		input.closest( formSelector )
			.addClass( this.focusedFieldsClass );

		input.closest( fieldSelector )
			.addClass( this.focusClass + ' ' + this.floatingLabelClass );
	}

	/**
	 * Blurs an input.
	 */
	blurInput( input, formSelector = this.formSelector, fieldSelector = this.fieldSelector ) {

		const field = input.closest( fieldSelector );

		input.closest( formSelector )
			.removeClass( this.focusedFieldsClass );

		field.removeClass( this.focusClass );

		if ( ! input.val() ) {

			field.removeClass( this.floatingLabelClass );
		}
	}

}

const form = new DispatchSkinForm();
export default form;



// WEBPACK FOOTER //
// ./src/js/inc/form.js